<script>
    /**
     * @typedef {Object} Props
     * @property {import('svelte').Snippet} [children]
     */
    let { children } = $props();
</script>

<div class="widget">
    {@render children?.()}
</div>

<style>
    .widget {
        max-width: 100%;
    }

    @media (max-width: 500px) {
        .widget {
            width: 100%;
        }
    }
</style>
